module.exports = __webpack_public_path__ + "img/pijltje-links-groen.8d39d039a71d5879dc496d2c7a531d61.svg";